import { render } from "./SearchAllEvents.vue?vue&type=template&id=1cbc1858"
import script from "./SearchAllEvents.vue?vue&type=script&lang=js"
export * from "./SearchAllEvents.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src2980638495/src/developer.gov.sg/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__